import { Group } from "@mantine/core";
import ActiveBtn from "../../Components/MantineDataTableBtns/ActiveBtn";
import EditBtn from "../../Components/MantineDataTableBtns/EditBtn";
import DeleteBtn from "../../Components/MantineDataTableBtns/DeleteBtn";

import { START_POLYGON, END_POLYGON,Price } from "Constant";
import { getCodeLabel } from "helper/getOptions";
// API
export const API = {
  list: (code) => `/front/profile/${code}/flatfees`,
  create: (code) => `/front/profile/${code}/flatfee`,
  get: (code) => `/front/flatfee/${code}`,
  put: (profileCode, codeFlatfee) => `/front/profile/${profileCode}/flatfee/${codeFlatfee}`,
  patch: (code) => `/front/flatfee/${code}`,
};

// Columns
export const COLUMNS = (profileCode) => [

  {
    name: "profile",
    selector: "profile",
  },
  {
    name: "Label",
    selector: "label",
  },
  {
    name: "Price",
    selector: "price",
  },
  /*{
    name: START_POLYGON,
    selector: "start_polygon",
  },
  {
    name: END_POLYGON,
    selector: "end_polygon",
  },*/
  {
    header: "Actions",
    id: "actions",
    button: "true",
    size: 120,
    Cell: ({ row }) => {
      const { code, active } = row.original;
      return (
        <Group gap="xs">
          <ActiveBtn patch={API.patch(code)} state={active} />
          <EditBtn read={API.get(code)} edit={API.put(profileCode, code)}/>
        {/*  <DeleteBtn delete={API.get + "/" + code} />*/}
        </Group>
      );
    },
  },
];
export const CREATE_ITEMS = [
  {
    title: "Label",
    placeholder: "label",
    name: "label",
    inputForm: "SimpleInput",
  },
  {
    title: "Price",
    placeholder: "Price",
    name: "price",
    inputForm: "SimpleInput",
    type: "number",
  },
  /*{
    title: START_POLYGON,
    name: "start_polygon",
    inputForm: "SelectApiInput",
    optionsApi: "/front/polygons/choices",
    getOptions: getCodeLabel,
  },
  {
    title: END_POLYGON,
    name: "end_polygon",
    inputForm: "SelectApiInput",
    optionsApi: "/front/polygons/choices",
    getOptions: getCodeLabel,
  },*/
  /*{
    title: "Active",
    name: "active",
    inputForm: "CheckBox",
    required: false,
  },*/
];

export const EDIT_ITEMS = [
  {
    title: "Label",
    placeholder: "label",
    name: "label",
    inputForm: "SimpleInput",
  },
  {
    title: "Price",
    placeholder: "Price",
    name: "price",
    inputForm: "SimpleInput",
    type: "number",
  },
  /*{
    title: START_POLYGON,
    name: "start_polygon",
    inputForm: "SelectApiInput",
    optionsApi: "/front/polygons/choices",
    getOptions: getCodeLabel,
  },
  {
    title: END_POLYGON,
    name: "end_polygon",
    inputForm: "SelectApiInput",
    optionsApi: "/front/polygons/choices",
    getOptions: getCodeLabel,
  },*/
];